package com.swetdot.swetgram.domain

enum class SquadStreakTypeDomain {
    DUO,
    GROUP,
    UNKNOWN;
}

data class SquadStreakParticipantDomain(
    val userId: String,
    val stepsCount: Int,
    val messagesSent: Int,
    val targetMet: Boolean,
) {
    val activeToday: Boolean get() = targetMet
    val contributedActions: Int get() = messagesSent + (stepsCount / 1000)
}

data class SquadStreakDomain(
    val id: String,
    val conversationId: String,
    val type: SquadStreakTypeDomain,
    val currentStreak: Int,
    val longestStreak: Int,
    val todayTargetMet: Boolean,
    val participants: List<SquadStreakParticipantDomain>,
    val updatedAt: String,
) {
    val allActiveToday: Boolean
        get() = todayTargetMet || (participants.isNotEmpty() && participants.all { it.targetMet })

    fun isParticipantActive(userId: String): Boolean =
        participants.any { it.userId == userId && it.targetMet }
}
